; (function (inovestor) {
    inovestor.ms.libRef = inovestor.ms.libRef || {};

    if (typeof module === "object" && typeof module.exports === "object") {
        inovestor.ms.libRef.highcharts = require("highcharts/highstock");
    } else {
        inovestor.ms.libRef.highcharts = window.Highcharts;
    }
})(inovestor);
; (function (Highcharts, inovestor) {
    // Create plugin namespace with any desired config variable
    inovestor.ms.chart = {};

    // Register plugins to core to change language when needed
    inovestor.ms.core.instances.register(inovestor.ms.chart, updateLanguages);

    Highcharts.setOptions({
        // Default color palette
        colors: ["#5089a8", "#10b292", "#ef8348", "#f0b922", "#de5b49", "#40bca4", "#fba63f", "#979795", "#fb9e87"],

        // Remove highcharts.com watermark
        credits: {
            enabled: false
        },

        exporting: {
            buttons: {
                contextButton: {
                    enabled: false
                }
            }
        },

        // Default tooltip displays the data right-aligned as, most of the time, we display numerical data.
        tooltip: {
            shared: true,
            split: false,
            valueDecimals: 2,
            useHTML: true,
            headerFormat: '<small>{point.key}</small><table>',
            pointFormat: '<tr><td><span style="color: {series.color}">●</span> {series.name}: </td><td style="text-align: right"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>'
        },

        plotOptions: {
            pie: {
                tooltip: {
                    headerFormat: '<strong>{point.key}</strong><br />',
                    pointFormat: '{point.percentage:.2f} %',
                    footerFormat: ''
                }
            }
        },

        chart: {
            style: {
                fontFamily: 'Arial,sans-serif',
                fontSize: '14px',
                color: '#333'
            }
        },

        title: {
            text: null
        },

        xAxis: {
            title: {
                text: null
            }
        },
        
        yAxis: {
            title: {
                text: null
            }
        }
    });

    function updateLanguages() {
        Highcharts.setOptions({ lang: inovestor.ms.chart.resources[inovestor.ms.core.currentLanguage] });
    }

})(inovestor.ms.libRef.highcharts, inovestor);


; (function (Highcharts, inovestor) {
    Highcharts.SparkLine = function (a, b, c) {
        var hasRenderToArg = typeof a === 'string' || a.nodeName,
            options = arguments[hasRenderToArg ? 1 : 0],
            defaultOptions = {
                chart: {
                    renderTo: (options.chart && options.chart.renderTo) || this,
                    backgroundColor: null,
                    borderWidth: 0,
                    type: 'column',
                    margin: [2, 0, 2, 0],
                    width: 120,
                    height: 20,
                    style: {
                        overflow: 'visible'
                    },
                    skipClone: true
                },
                xAxis: {
                    labels: {
                        enabled: false
                    },
                    startOnTick: false,
                    endOnTick: false,
                    tickPositions: []
                },
                yAxis: {
                    endOnTick: false,
                    startOnTick: false,
                    labels: {
                        enabled: false
                    },
                    tickPositions: [0]
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    enabled:false,
                    backgroundColor: null,
                    borderWidth: 0,
                    shadow: false,
                    hideDelay: 0,
                    padding: 0,
                    positioner: function (w, h, point) {
                        return { x: point.plotX - w / 2, y: point.plotY - h };
                    }
                },
                plotOptions: {
                    series: {
                        animation: false,
                        lineWidth: 1,
                        shadow: false,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        marker: {
                            radius: 1,
                            states: {
                                hover: {
                                    radius: 2
                                }
                            }
                        },
                        fillOpacity: 0.25,
                        groupPadding: 0
                    },
                    column: {
                        color: '#5089A8',
                        negativeColor: '#a94442',
                        borderColor: 'silver',
                        pointWidth: 6
                    }
                }
            };

        options = Highcharts.merge(defaultOptions, options);

        return hasRenderToArg ?
            new Highcharts.Chart(a, options, c) :
            new Highcharts.Chart(options, b);
    };

})(inovestor.ms.libRef.highcharts, inovestor);


; (function (inovestor, undefined) {
    inovestor.ms.chart.resources = inovestor.ms.chart.resources || {};
    inovestor.ms.chart.resources["en"] = {
        loading: 'Loading...',
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        decimalPoint: '.',
        numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'], // SI prefixes used in axis labels
        resetZoom: 'Reset zoom',
        resetZoomTitle: 'Reset zoom (1x)',
        thousandsSep: ','
    };
})(inovestor);

; (function (inovestor, undefined) {
    inovestor.ms.chart.resources = inovestor.ms.chart.resources || {};
    inovestor.ms.chart.resources["fr"] = {
        loading: 'Chargement en cours…',
        months: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
        shortMonths: ['jan', 'févr', 'mar', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'],
        weekdays: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
        decimalPoint: ',',
        numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'], // SI prefixes used in axis labels
        resetZoom: 'Réinitialiser le zoom',
        resetZoomTitle: 'Réinitialiser le zoom (x1)',
        thousandsSep: ' '
    };
})(inovestor);
